import "./dashboard.page.style.scss";
import { FC } from "react";
import LayoutComponent from "../../layouts/layoutComponent/layout.component";
import KeyWordLocalization from "../../utils/KeyWordLocalization";
import BarSatifactionComponent from "./components/barSatisfaction/BarSatisfactionComponent";
import TableSatisfactionComponent from "./components/tableSatisfaction/table_satisfaction.component";
import CardFeelingComponent from "./components/cardFeeling/CardFeelingComponent";
import ReasonsForCallComponent from "./components/reasonsForCall/ReasonsForCallComponent";
import TargetCircleComponent from "./components/targetCircle/TargetCircleComponent";
import { ErrorMessage } from "@hookform/error-message";
import Validators from "../../utils/Validators";
import ButtonComponent from "../../components/button/button.component";
import CardLoaderComponent from "./components/card_loader/card_loader.component";
import BarCardComponent from "./components/bar_card/bar_card_component";
import LineCardComponent from "./components/line_card/line_card_component";
import AutoCompleteWithCheckComponent from "../../components/autocompleteWithCheck/AutoCompleteWithCheckComponent";
import useDashboardPageViewModel from "./dashboard.page.view_model";
import MasterItemEntity from "../../../domain/entities/master_item.entity";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useNavigate } from 'react-router-dom';
import routes from "../../routes/Routes";

const DashboardPage: FC<{}> = () => {
  const {
    handleSubmit,
    _onSubmit,
    errors,
    register,
    setData,
    i18n,
    _onSearchHuman,
    formInfo,
    handleChangeHumanAgent,
    onSearchAiAgent,
    handleChangeAiAgent,
    loaded,
    _handleSeeAgentDetails,
    colors,
    parsedChartData,
    watch,
    data,
    _getPercentFeelings,
    _onSearchOpTypes,
    handleChangeOpType,
    handleChangeForm,
    typesCall,
    _handleClickCompleted,
    _handleClickNotRated,
    _handleClickNegativeSentiment,
    _handleClickNeutralSentiment,
    _handleClickPositiveSentiment,

  } = useDashboardPageViewModel();
  const navigate = useNavigate();

  return (
    <div className="dashboard_page">
      <LayoutComponent title="Dashboard">
        <div className="container">
          <form onSubmit={handleSubmit(_onSubmit)}>
            <div className="row">
              <div
                className={`form-group pt-2 col-md-4 my-2 ${errors[KeyWordLocalization.DashboardPageOpTypeForm] &&
                  "error error_group"
                  }`}
              >
                <AutoCompleteWithCheckComponent
                  multiple={false}
                  keyName={KeyWordLocalization.DashboardPageOpTypeForm}
                  label={i18n(KeyWordLocalization.DashboardPageOpTypeForm)}
                  formInfo={formInfo}
                  onSearch={_onSearchOpTypes}
                  onChange={handleChangeOpType}
                />
              </div>
              <div className="orm-group pt-2 col-md-4 my-2">
                <AutoCompleteWithCheckComponent
                  multiple={false}
                  keyName={KeyWordLocalization.QAResumeEntityHumanAgentName}
                  label={i18n(KeyWordLocalization.QAResumeEntityHumanAgentName)}
                  formInfo={formInfo}
                  onSearch={_onSearchHuman}
                  onChange={handleChangeHumanAgent}
                />
              </div>
              <div className="form-group pt-2 col-md-4 my-2">
                <AutoCompleteWithCheckComponent
                  multiple={false}
                  keyName={KeyWordLocalization.DashboardPageFormForm}
                  label={i18n(KeyWordLocalization.DashboardPageFormForm)}
                  formInfo={formInfo}
                  onSearch={onSearchAiAgent}
                  onChange={handleChangeAiAgent}
                />
              </div>
              <div className="form-group col-md-6 my-2">
                <label className="form-label">
                  {i18n(KeyWordLocalization.QAResumeEntityCallType)}
                </label>
                <select
                  className="form-control"
                  {...register(
                    KeyWordLocalization.QAResumeEntityCallType,
                    Validators({
                      onChange: handleChangeForm,
                    })
                  )}
                >
                  <option value={""}>
                    {i18n(KeyWordLocalization.QAResumeEntityCallType)}
                  </option>
                  {typesCall.map((reason: MasterItemEntity, index: number) => (
                    <option value={reason.id} key={index}>
                      {reason.name}
                    </option>
                  ))}
                </select>
              </div>
              <div
                className={`form-group col-md-2 my-2 ${errors[KeyWordLocalization.DashboardPageDateFromForm]
                  ? "error"
                  : ""
                  }`}
              >
                <label className="form-label">
                  {i18n(KeyWordLocalization.DashboardPageDateFromForm)}
                </label>
                <input
                  type="date"
                  className="form-control"
                  max={new Date().toISOString().split("T")[0]}
                  {...register(
                    KeyWordLocalization.DashboardPageDateFromForm,
                    Validators({
                      onChange: handleChangeForm,
                    })
                  )}
                />
                <ErrorMessage
                  as="aside"
                  errors={errors}
                  name={KeyWordLocalization.DashboardPageDateFromForm}
                />
              </div>
              <div
                className={`form-group col-md-2 my-2 ${errors[KeyWordLocalization.DashboardPageDateToForm]
                  ? "error"
                  : ""
                  }`}
              >
                <label className="form-label">
                  {i18n(KeyWordLocalization.DashboardPageDateToForm)}
                </label>
                <input
                  type="date"
                  className="form-control"
                  max={new Date().toISOString().split("T")[0]}
                  {...register(
                    KeyWordLocalization.DashboardPageDateToForm,
                    Validators({
                      greaterOrEqualThan: watch(
                        KeyWordLocalization.DashboardPageDateFromForm
                      ),
                      onChange: handleChangeForm,
                    })
                  )}
                />
                <ErrorMessage
                  as="aside"
                  errors={errors}
                  name={KeyWordLocalization.DashboardPageDateToForm}
                />
              </div>
              <div className="col-md-2 my-2 d-flex align-items-end" style={{gap: "1rem"}}>
                <ButtonComponent
                  design="primaryOutline"
                  className="w-100 justify-content-center"
                  type="submit"
                  icon={
                    <span className="material-symbols-outlined">search</span>
                  }
                //   text={i18n(KeyWordLocalization.Search)}
                />

                <ButtonComponent
                  design="dangerOutline"
                  className="w-100 justify-content-center"
                  type="button"
                  icon={<span className="material-symbols-outlined">restart_alt</span>}
                  onClick={() => {
                    formInfo.reset({
                      [KeyWordLocalization.DashboardPageOpTypeForm]: [],
                      [KeyWordLocalization.QAResumeEntityHumanAgentName]: [],
                      [KeyWordLocalization.DashboardPageFormForm]: [],
                      [KeyWordLocalization.QAResumeEntityCallType]: "",
                      [KeyWordLocalization.DashboardPageDateFromForm]: "",
                      [KeyWordLocalization.DashboardPageDateToForm]: "",
                    });
                    setData(undefined);
                    navigate(routes.home.relativePath);
                    _onSubmit(formInfo.getValues());
                  }}
                />
              </div>



            </div>
          </form>
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-md-5">
                  <div className="row">
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.totalCalls != null}
                      className="col-12 my-3"
                    >
                      {data?.totalCalls != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageTotalCalls
                          )}
                          total={data!.totalCalls!}
                          icon={
                            <span className="material-symbols-outlined">
                              call
                            </span>
                          }
                        />
                      )}
                    </CardLoaderComponent>
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.averages?.completed != null}
                      className="col-md-6 my-3"
                    >
                      {data?.averages?.completed != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageTotalCompleted
                          )}
                          total={data!.averages!.completed!.total}
                          onClick={_handleClickCompleted}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </CardLoaderComponent>
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.averages?.failed.total != null}
                      className="col-md-6 my-3"
                    >
                      {data?.averages?.failed.total != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageTotalNotRated
                          )}
                          total={data!.averages!.notRated.total}
                          onClick={_handleClickNotRated}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </CardLoaderComponent>
                  </div>
                </div>
                <div className="col-md-7 d-flex flex-column">
                  <div className="grafics">
                    {/* <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.averages != null}
                      className="col-lg-4 col-md-6 my-3"
                    >
                      {data?.averages != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageAverageCallScore
                          )}
                          total={
                            data!.averages!.completed.calls.toFixed(1) + "%"
                          }
                        />
                      )}
                    </CardLoaderComponent> */}
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.averages != null}
                      className="col-lg-4 col-md-6 my-3"
                    >
                      {data?.averages != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageAverageAgentScore
                          )}
                          total={
                            data!.averages!.completed.agent.toFixed(1) + "%"
                          }
                        />
                      )}
                    </CardLoaderComponent>
                    {/* <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.averages != null}
                      className="col-lg-4 col-md-6 my-3"
                    >
                      {data?.averages != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageAverageCustomerScore
                          )}
                          total={
                            data!.averages!.completed.customer.toFixed(1) + "%"
                          }
                        />
                      )}
                    </CardLoaderComponent> */}
                  </div>
                  <div className="grafics2">
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.totalSentiments != null}
                      className="col-lg-4 col-md-6 my-3"
                    >
                      {data?.totalSentiments != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageSentimentNegative
                          )}
                          total={data!.totalSentiments!.negative}
                          color={colors[0]}
                          icon={
                            <span className="material-symbols-outlined">
                              sentiment_dissatisfied
                            </span>
                          }
                          percentage={_getPercentFeelings([
                            data!.totalSentiments!.negative,
                          ])}
                          onClick={_handleClickNegativeSentiment}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </CardLoaderComponent>
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.totalSentiments != null}
                      className="col-lg-4 col-md-6 my-3"
                    >
                      {data?.totalSentiments != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageSentimentNeutral
                          )}
                          total={data!.totalSentiments!.neutral}
                          color={colors[1]}
                          icon={
                            <span className="material-symbols-outlined">
                              sentiment_neutral
                            </span>
                          }
                          percentage={_getPercentFeelings([
                            data!.totalSentiments!.neutral,
                          ])}
                          onClick={_handleClickNeutralSentiment}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </CardLoaderComponent>
                    <CardLoaderComponent
                      loading={!loaded}
                      condition={data?.totalSentiments != null}
                      className="col-lg-4 col-md-6 my-3"
                    >
                      {data?.totalSentiments != null && (
                        <CardFeelingComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageSentimentPositive
                          )}
                          total={data!.totalSentiments!.positive}
                          color={colors[2]}
                          icon={
                            <span className="material-symbols-outlined">
                              sentiment_satisfied
                            </span>
                          }
                          percentage={_getPercentFeelings([
                            data!.totalSentiments!.positive,
                          ])}
                          onClick={_handleClickPositiveSentiment}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </CardLoaderComponent>
                  </div>
                </div>

                <div className="grafics3">
                  <div className="row">
                    {/* Columna izquierda: Gráfica arriba, Target abajo */}
                    <div className="col-lg-6">
                      <div className="row">
                        {/* Gráfica de barras */}
                        <div className="col-12 mb-3">
                          <CardLoaderComponent
                            loading={!loaded}
                            condition={data?.dayToDay != null}
                            className="b-none"
                            style={{ minHeight: 200 }}
                          >
                            {data?.dayToDay != null && (
                              <div className="card">
                                <div className="card-body card-grafic">
                                  <BarSatifactionComponent
                                    title={
                                      <div className="d-flex align-items-center gap-2">
                                        <span>{i18n(KeyWordLocalization.DashboardPageSentimentsOnTime)}</span>

                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id="tooltip-info">
                                              {i18n(KeyWordLocalization.DashboardTooltipSentimentsOnTime)}
                                            </Tooltip>
                                          }
                                        >
                                          <img
                                            src="/assets/info.png"
                                            alt="info"
                                            width={20}
                                            style={{ cursor: 'pointer' }}
                                          />
                                        </OverlayTrigger>
                                      </div>
                                    }
                                    chartData={parsedChartData()}
                                    yTitle={i18n(KeyWordLocalization.DashboardPageTotalCalls)}
                                  />

                                </div>
                              </div>
                            )}
                          </CardLoaderComponent>
                        </div>

                        {/* Target Circle */}
                        <div className="col-12">
                          <CardLoaderComponent
                            loading={!loaded}
                            condition={data?.target != null}
                            className="mb-3"
                          // style={{ minHeight: 270 }}
                          >
                            {data?.target != null && (
                              <div className="card">
                                <div className="card-body">
                                  <div className="d-flex align-items-center gap-2 mb-3">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-target">
                                          {i18n(KeyWordLocalization.DashboardTooltipTarget)}
                                        </Tooltip>
                                      }
                                    >
                                      <img
                                        src="/assets/info.png"
                                        alt="info"
                                        width={20}
                                        style={{ cursor: 'pointer' }}
                                      />
                                    </OverlayTrigger>
                                  </div>
                                  <TargetCircleComponent
                                    target={data!.target!.serviceLevel}
                                    current={data!.target!.current}
                                    increment={data!.target!.increment}
                                  />
                                </div>
                              </div>
                            )}
                          </CardLoaderComponent>
                        </div>
                      </div>
                    </div>

                    {/* Columna derecha: Razones de llamada */}
                    <div className="col-lg-6">
                      <CardLoaderComponent
                        loading={!loaded}
                        condition={data?.reasonForCalls != null}
                        className="mb-3"
                        style={{ minHeight: 580 }}
                      >
                        {data?.reasonForCalls != null && (
                          <div className="card">
                            <div className="card-body c-grafic" style={{ padding: 0 }}>
                              {/* Contenedor con scroll */}
                              <div
                                style={{
                                  maxHeight: '590px',
                                  overflowY: 'auto',
                                  position: 'relative',
                                  padding: '1rem', // relleno interno del scroll
                                }}
                              >
                                {/* Título sticky */}
                                <div
                                  style={{
                                    position: 'sticky',
                                    top: 0,
                                    background: 'black',
                                    fontSize: '1.3rem',
                                    zIndex: 1,
                                    paddingBottom: '0.5rem',
                                    marginBottom: '1rem',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <span>
                                      {i18n(KeyWordLocalization.DashboardPageReasonsForCall)}
                                    </span>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-reasons">
                                          {i18n(KeyWordLocalization.DashboardTooltipReasonsForCall)}
                                        </Tooltip>
                                      }
                                    >
                                      <img
                                        src="/assets/info.png"
                                        alt="info"
                                        width={20}
                                        style={{ cursor: 'pointer' }}
                                      />
                                    </OverlayTrigger>
                                  </div>
                                </div>

                                {/* Contenido de razones con scroll */}
                                <ReasonsForCallComponent
                                  data={data!.reasonForCalls!.map((reason) => ({
                                    name: reason.name,
                                    count: reason.count,
                                  }))}
                                  // Aquí pasamos el title solo si es requerido por tipado, pero puede ir vacío si ya lo mostramos arriba
                                  title={null as any} // 👈 si es obligatorio, pero no quieres que lo muestre otra vez
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </CardLoaderComponent>
                    </div>

                  </div>
                </div>

                {/* <div className="grafics2">
                  <CardLoaderComponent
                    loading={!loaded}
                    condition={data?.dayToDay != null}
                    className="b-none my-3"
                    style={{ minHeight: 500 }}
                  >
                    {data?.dayToDay != null && (
                      <div className="card">
                        <div className="card-body card-grafic">
                          <BarSatifactionComponent
                            title={i18n(
                              KeyWordLocalization.DashboardPageSentimentsOnTime
                            )}
                            chartData={parsedChartData()}
                            yTitle={i18n(
                              KeyWordLocalization.DashboardPageTotalCalls
                            )}
                          />
                        </div>
                      </div>
                    )}
                  </CardLoaderComponent>
                  <CardLoaderComponent
                  loading={!loaded}
                  condition={data?.reasonForCalls != null}
                  className="col-md-6 col-lg-12"
                  style={{ minHeight: 410 }}
                >
                  {data?.reasonForCalls != null && (
                    <div className="card">
                      <div className="card-body">
                        <ReasonsForCallComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageReasonsForCall
                          )}
                          data={data!.reasonForCalls!.map((reason) => {
                            return {
                              name: reason.name,
                              count: reason.count,
                            };
                          })}
                        />
                      </div>
                    </div>
                  )}
                </CardLoaderComponent>
                </div> */}
                <div className="col-md-6">
                  <CardLoaderComponent
                    loading={!loaded}
                    condition={data?.avgScorePerCategory != null}
                    className="b-none my-3"
                  >
                    {data?.avgScorePerCategory != null && (
                      <div className="card">
                        <div className="card-body">
                          <BarCardComponent
                            data={data!.avgScorePerCategory!.map((category) => ({
                              label: category.category,
                              value: category.score,
                            }))}
                            title={
                              <div className="d-flex align-items-center gap-2">
                                <span>{i18n(KeyWordLocalization.DashboardPageAvgScorePerCategory)}</span>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-avgscore">
                                      {i18n(KeyWordLocalization.DashboardTooltipAvgScorePerCategory)}
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    src="/assets/info.png"
                                    alt="info"
                                    width={20}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </OverlayTrigger>
                              </div>
                            }
                          />
                        </div>
                      </div>
                    )}
                  </CardLoaderComponent>
                </div>
                <div className="col-md-6">
                  <CardLoaderComponent
                    loading={!loaded}
                    condition={data?.avgScorePerQuestion != null}
                    className="b-none my-3"
                  >
                    {data?.avgScorePerQuestion != null && (
                      <div className="card">
                        <div className="card-body">
                          <BarCardComponent
                            showXaxis={false}
                            data={data!.avgScorePerQuestion!.map((question) => {
                              return {
                                label: question.question,
                                value: question.score,
                              };
                            })}
                            title={
                              <div className="d-flex align-items-center gap-2">
                                <span>{i18n(KeyWordLocalization.DashboardPageAvgScorePerQuestion)}</span>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-question-score">
                                      {i18n(KeyWordLocalization.DashboardTooltipAvgScorePerQuestion)}
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    src="assets/info.png"
                                    alt="info"
                                    width={20}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </OverlayTrigger>
                              </div>
                            }
                          />
                        </div>
                      </div>
                    )}
                  </CardLoaderComponent>
                </div>

                <div className="col-md-6">
                  <CardLoaderComponent
                    loading={!loaded}
                    condition={data?.avgScorePerWeek != null}
                    className="b-none my-3"
                  >
                    {data?.avgScorePerWeek != null && (
                      <div className="card">
                        <div className="card-body">
                          <LineCardComponent
                            data={data!.avgScorePerWeek!.map((week) => {
                              return {
                                label: week.week,
                                value: week.score,
                              };
                            })}
                            title={
                              <div className="d-flex align-items-center gap-2">
                                <span>{i18n(KeyWordLocalization.DashboardPageAvgScorePerWeek)}</span>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-avg-score-week">
                                      {i18n(KeyWordLocalization.DashboardTooltipAvgScorePerWeek)}
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    src="assets/info.png"
                                    alt="info"
                                    width={20}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </OverlayTrigger>
                              </div>
                            }
                          />
                        </div>
                      </div>
                    )}
                  </CardLoaderComponent>
                </div>

                <div className="col-md-6">
                  <CardLoaderComponent
                    loading={!loaded}
                    condition={data?.avgScorePerTypeCall != null}
                    className="b-none my-3"
                  >
                    {data?.avgScorePerTypeCall != null && (
                      <div className="card">
                        <div className="card-body">
                          <BarCardComponent
                            data={data.avgScorePerTypeCall.map((typecall) => ({
                              label: typecall.type,
                              value: typecall.score,
                            }))}
                            title={
                              <div className="d-flex align-items-center gap-2">
                                <span>{i18n(KeyWordLocalization.DashboardPageAvgScorePerTypeCall)}</span>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-avg-score-type-call">
                                      {i18n(KeyWordLocalization.DashboardTooltipAvgScorePerTypeCall)}
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    src="assets/info.png"
                                    alt="info"
                                    width={20}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </OverlayTrigger>
                              </div>
                            }
                          />
                        </div>
                      </div>
                    )}
                  </CardLoaderComponent>
                </div>

              </div>
            </div>
            {/* <CardLoaderComponent
                  loading={!loaded}
                  condition={data?.reasonForCalls != null}
                  className="col-md-6 col-lg-12"
                  style={{ minHeight: 410 }}
                >
                  {data?.reasonForCalls != null && (
                    <div className="card">
                      <div className="card-body">
                        <ReasonsForCallComponent
                          title={i18n(
                            KeyWordLocalization.DashboardPageReasonsForCall
                          )}
                          data={data!.reasonForCalls!.map((reason) => {
                            return {
                              name: reason.name,
                              count: reason.count,
                            };
                          })}
                        />
                      </div>
                    </div>
                  )}
                </CardLoaderComponent> */}

            <div className="col-12">
              <div className="emotions">
                <CardLoaderComponent
                  loading={!loaded}
                  condition={data?.bestClients != null}
                >
                  {data?.bestClients != null && (
                    <div className="card b-none my-3">
                      <div className="card-body">
                        <TableSatisfactionComponent
                          title={
                            <div className="d-flex align-items-center gap-2">
                              <span>{i18n(KeyWordLocalization.DashboardPageBestClients)}</span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-best-clients">
                                    {i18n(KeyWordLocalization.DashboardTooltipBestClients)}
                                  </Tooltip>
                                }
                              >
                                <img
                                  src="assets/info.png"
                                  alt="info"
                                  width={20}
                                  style={{ cursor: 'pointer' }}
                                />
                              </OverlayTrigger>
                            </div>
                          }
                          data={data.bestClients}
                          openAgentDetails={_handleSeeAgentDetails}
                          colors={colors}
                        />
                      </div>
                    </div>
                  )}
                </CardLoaderComponent>

                <CardLoaderComponent
                  loading={!loaded}
                  condition={data?.worstClients != null}
                  className="col-md-6"
                >
                  {data?.worstClients != null && (
                    <div className="card b-none my-3">
                      <div className="card-body">
                        <TableSatisfactionComponent
                          title={
                            <div className="d-flex align-items-center gap-2">
                              <span>{i18n(KeyWordLocalization.DashboardPageWorstClients)}</span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-worst-clients">
                                    {i18n(KeyWordLocalization.DashboardTooltipWorstClients)}
                                  </Tooltip>
                                }
                              >
                                <img
                                  src="assets/info.png"
                                  alt="info"
                                  width={20}
                                  style={{ cursor: 'pointer' }}
                                />
                              </OverlayTrigger>
                            </div>
                          }
                          data={data.worstClients}
                          openAgentDetails={_handleSeeAgentDetails}
                          colors={colors}
                        />
                      </div>
                    </div>
                  )}
                </CardLoaderComponent>

              </div>
            </div>
          </div>
        </div>
      </LayoutComponent>
    </div>
  );
};

export default DashboardPage;
